import React, { useState, useEffect, useRef } from 'react';
import bem from 'utils/bem';
import MobileMenuButton from '../MobileMenuButton';
import MobileMenuBody from '../MobileMenuBody';

import './MobileMenu.sass';
import { useBeforeUnload } from 'react-router-dom';
import { useLocation } from 'react-router';

const { block, el } = bem('mobile-menu');

const ControlledMobileMenu = ({ data, anchor, mods, isOpen, setIsOpen }) => {

    useEffect(() => {
        document.body.classList.toggle('mobile-menu-is-open', isOpen);
    }, [isOpen]);
    const onButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(old => !old);
    }

    const location = useLocation();
    const initialPage = useRef(location.pathname);


    useEffect(() => {
        setIsOpen(false)
        if (location.pathname !== initialPage.current) {
            initialPage.current = location.pathname;
        }
    }, [location]);

    return (
        <div className={ block({ 'is-open': isOpen, ...mods}) }>
            { anchor && <MobileMenuBody items={ data } isOpen={ isOpen } anchor={ anchor } mods={mods}/> }
            <div className={ el('menu-button', mods) }>
                <MobileMenuButton mod={ (isOpen) ? 'close' : 'menu' }
                                  onClick={ onButtonClick }/>
            </div>
        </div>
    )
}

const UncontrolledMobileMenu = (props) => {
    const [ isOpen, setIsOpen ] = useState(false);

    const location = useLocation();
    const initialPage = useRef(location.pathname);

    useEffect(() => {
        setIsOpen(false)
        if (location.pathname !== initialPage.current) {
            initialPage.current = location.pathname;
        }
    }, [location]);

    return <ControlledMobileMenu {...props} isOpen={isOpen} setIsOpen={setIsOpen}/>
}

const MobileMenu = (props) => {
    return typeof(props.isOpen) !== 'undefined' ?
        <ControlledMobileMenu {...props} /> :
        <UncontrolledMobileMenu {...props} />;
}

export default MobileMenu;
export { ControlledMobileMenu }
